import React from 'react';

const fieldStyle = {
  width: '100%', padding: '0.375rem 0.75rem', fontSize: '0.875rem',
  border: '1px solid var(--border)', borderRadius: '0.375rem', outline: 'none'
};

const labelStyle = { display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', fontWeight: '500' };

const WarehouseModal = ({ isOpen, editingWarehouse, warehouseForm, setWarehouseForm, locations, users, onSubmit, onClose, loading }) => {
  if (!isOpen) return null;

  const update = (field, value) => setWarehouseForm(prev => ({ ...prev, [field]: value }));

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 1050
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '0.375rem', padding: '1.5rem',
        minWidth: '600px', maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.15)'
      }}>
        <h5 style={{ marginBottom: '1rem', fontWeight: '600' }}>
          {editingWarehouse ? 'Edytuj magazyn' : 'Dodaj nowy magazyn'}
        </h5>

        <form onSubmit={onSubmit}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <label style={labelStyle}>Nazwa magazynu *</label>
              <input type="text" required style={fieldStyle} value={warehouseForm.nazwa}
                onChange={(e) => update('nazwa', e.target.value)} placeholder="Nazwa magazynu" />
            </div>
            <div>
              <label style={labelStyle}>Kod magazynu *</label>
              <input type="text" required style={fieldStyle} value={warehouseForm.kod}
                onChange={(e) => update('kod', e.target.value)} placeholder="MAG001" />
            </div>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={labelStyle}>Lokalizacja *</label>
            <select required style={{ ...fieldStyle, backgroundColor: 'var(--card-bg)' }} value={warehouseForm.location_id}
              onChange={(e) => update('location_id', e.target.value)}>
              <option value="">Wybierz lokalizacje</option>
              {locations.map(loc => (
                <option key={loc.id} value={loc.id}>
                  {loc.nazwa || loc.name} {loc.miasto ? `(${loc.miasto})` : ''}
                </option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={labelStyle}>Adres</label>
            <input type="text" style={fieldStyle} value={warehouseForm.adres}
              onChange={(e) => update('adres', e.target.value)} placeholder="Ulica i numer" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <label style={labelStyle}>Miasto</label>
              <input type="text" style={fieldStyle} value={warehouseForm.miasto}
                onChange={(e) => update('miasto', e.target.value)} placeholder="Miasto" />
            </div>
            <div>
              <label style={labelStyle}>Kod pocztowy</label>
              <input type="text" style={fieldStyle} value={warehouseForm.kod_pocztowy}
                onChange={(e) => update('kod_pocztowy', e.target.value)} placeholder="00-000" />
            </div>
            <div>
              <label style={labelStyle}>Wojewodztwo</label>
              <input type="text" style={fieldStyle} value={warehouseForm.wojewodztwo}
                onChange={(e) => update('wojewodztwo', e.target.value)} placeholder="Wojewodztwo" />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <label style={labelStyle}>Telefon</label>
              <input type="tel" style={fieldStyle} value={warehouseForm.telefon}
                onChange={(e) => update('telefon', e.target.value)} placeholder="+48 123 456 789" />
            </div>
            <div>
              <label style={labelStyle}>Email</label>
              <input type="email" style={fieldStyle} value={warehouseForm.email}
                onChange={(e) => update('email', e.target.value)} placeholder="email@example.com" />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
            <div>
              <label style={labelStyle}>Typ magazynu</label>
              <select style={{ ...fieldStyle, backgroundColor: 'var(--card-bg)' }} value={warehouseForm.typ_magazynu}
                onChange={(e) => update('typ_magazynu', e.target.value)}>
                <option value="sklep">Sklep</option>
                <option value="magazyn">Magazyn</option>
                <option value="hurtownia">Hurtownia</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Kierownik</label>
              <select style={{ ...fieldStyle, backgroundColor: 'var(--card-bg)' }} value={warehouseForm.kierownik_id}
                onChange={(e) => update('kierownik_id', e.target.value)}>
                <option value="">Wybierz kierownika</option>
                {users.map(user => (
                  <option key={user.id} value={user.id}>{user.login} ({user.role})</option>
                ))}
              </select>
            </div>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={labelStyle}>Opis</label>
            <textarea
              style={{ ...fieldStyle, resize: 'vertical', minHeight: '80px' }}
              value={warehouseForm.opis}
              onChange={(e) => update('opis', e.target.value)}
              placeholder="Dodatkowe informacje o magazynie"
            />
          </div>

          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <button type="button" onClick={onClose}
              style={{ padding: '6px 12px', fontSize: '12px', fontWeight: '500', color: 'var(--text-muted)', backgroundColor: 'var(--card-bg)', border: '1px solid var(--text-muted)', cursor: 'pointer' }}>
              Anuluj
            </button>
            <button type="submit" disabled={loading}
              style={{ padding: '6px 12px', fontSize: '12px', fontWeight: '600', color: '#fff' , backgroundColor: 'var(--success)', border: '1px solid var(--success)', cursor: 'pointer' }}>
              {loading ? 'Zapisywanie...' : (editingWarehouse ? 'Zapisz zmiany' : 'Dodaj magazyn')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WarehouseModal;
